import React, { Component } from "react";
import { Link } from "@reach/router";
import VimeoPlayer from "~/scripts/components/VimeoPlayer";

class VideoPage extends Component {
    state = {
        data: {}
    };

    componentDidMount() {
        const { slug, id, onMount } = this.props;

        if (onMount) {
            onMount();
        }

        this.load(slug, id);
    }

    async load(slug, id) {
        const response = await fetch(`/api/films/${slug}/${id}`);

        const data = await response.json();

        this.setState({ data });
    }

    handleClick = () => {
        const { toggleSpecialPageTransition } = this.props;

        toggleSpecialPageTransition(true, null, true);
    };

    videoPlayerOrImage = data => {
        let el = "";

        if (data && data.url && data.url.includes("vimeo")) {
            el = (
                <VimeoPlayer
                    url={data.url}
                    autoplay={true}
                    playsinline={false}
                />
            );
        } else if (data && data.url) {
            el = <img className="posterImage" src={data.url} />;
        }

        return el;
    };

    render() {
        const {
            entryType,
            slug,
            location: { state }
        } = this.props;
        const { data } = this.state;

        const theme = state ? state.theme : null;

        const itemElement = this.videoPlayerOrImage(data);

        const closeLink =
            entryType === "line-production"
                ? `/${entryType}`
                : `/${entryType}/${slug}`;

        return (
            <div className="video-page">
                <div className="video-page__content">
                    <div className="video-page__video">
                        <div className="video-page__vimeo">
                            {data && data.url && itemElement}
                        </div>

                        <Link
                            className="video-page__close"
                            to={`${closeLink}`}
                            state={{ id: data.id, theme }}
                            onClick={this.handleClick}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default VideoPage;



// WEBPACK FOOTER //
// ./src/scripts/components/VideoPage.js